import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';

import routerAdmin from './admin';
import routerPC from './pc';
import routerSP from './sp';

import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';
// import { AuthService } from "@/services/common/auth.service";

Vue.use(Router);

// Conpact router
let allRoutes = [];
routerPC.forEach((pc, idxPc) => {
    routerSP.forEach((sp, idxSp) => {
        if (pc.path == sp.path) {
            let _components = Object.assign(pc.components, sp.components);
            routerPC[idxPc].components = _components;
            routerSP.splice(idxSp, 1);
        }
    });
});

allRoutes = allRoutes.concat(routerAdmin, routerPC, routerSP);

// Const router
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: allRoutes,
    duplicateNavigationPolicy: 'ignore',
});

router.beforeEach((to, from, next) => {
    const fromPages = ['PcLoginMfa', 'PcLoginFirstMfa', 'SpLoginMfa', 'SpLoginFirstMfa'];
    const toPages = ['PcResetPassword', 'SpResetPassword'];
    const clickChangePass = StorageService.getClickChangePass();
    if (fromPages.includes(from.name) && toPages.includes(to.name) && !clickChangePass) {
        AuthService.logout();
    } else {
      next();
    }
  });

// Router before & after
router.beforeResolve((to, from, next) => {
    // console.log(' router.beforeResolve ');
// console.log('to = ' + JSON.stringify(to) + ', from = ' + JSON.stringify(from) );
// if ("/login" == to.path) {
// console.log('ignore check route');
//
// }
    if (to.name) {
        const loggedIn = !!((StorageService.getToken() || StorageService.getRefreshToken()));
        const isPublic = to.matched.some(record => record.meta.public);
        // console.log("isPublic" + isPublic);
        // console.log("isPublic" + loggedIn);
        // TODO need to check login by other way
        if (!isPublic && !loggedIn) {
            // console.log('redirect to login');
            // return next({
            //     path: '/login',
            //     query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
            // });
            return AuthService.doLogout();
        }

        const { authorize } = to.meta;
        // console.log('step here');

        const userRole = StorageService.getUserRole();
        // console.log('user role = ' + userRole);
        if (userRole) {
            // console.log(authorize.includes(1));
            // console.log(authorize);
            // console.log('authorize include = ' + authorize.includes(parseInt(userRole)));
            // check if route is restricted by role
            if (authorize && !authorize.includes(parseInt(userRole))) {
                // role not authorised so logout
                // TODO not logout, show Permision Denied error
                // AuthService.logout();
                // console.log('not authorize');
                return;
            }
        } else {
            // console.log('user role null');
        }
        // NProgress.start();
    }
    // console.log('go next')
    next();
});

router.afterEach((to, from) => {
    // console.log('route after');
    NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js